import useShallowEqualSelector from '../components/core/useShallowEqualSelector';

// eslint-disable-next-line import/prefer-default-export
export const useAppLocale = () => useShallowEqualSelector((state) => state?.user?.currentLocale);
